(function(Drupal, $, once){
    Drupal.behaviors.or21 = {
        attach() {
            $(once('or21', 'body')).first().each(function(){
                var componentClass = '.OR21';
                var carouselClass = '.OR21__carousel';

                var $carousel = $(carouselClass);

                function getComponentInstance(context) {
                    return $(context).closest(componentClass);
                }

                $carousel.each(function() {
                    var $component = getComponentInstance(this);
                    // Check if slick is not initialized earlier on same element.
                    $(this).not('.slick-initialized').slick({
                        infinite: false,
                        dots: true,
                        arrows: false,
                        dotsClass: 'OR21__indicators unstyled',
                        appendDots: $component.find('.OR21__indicator-container'),
                    });
                });

                $('.OR21__next-button').click(() => {
                    $carousel.slick("slickNext");
                });
            });
        }
    };
})(Drupal, jQuery, once);
